import React from "react";
//#region types
import { IconProfileProps } from "models/propTypes/userProfilePropTypes";
//#endregion
//#region components
import Icon from "../icon";
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const IconProfile: React.FC<IconProfileProps> = (props) => {
  return (
    <Grid
      container
      direction="row"
      columnGap={2}
      alignItems="center"
      wrap="nowrap"
      className={clsx(cssExports.iconProfile, props.hideIconBackground ? cssExports.noBackground : "")}
    >
      <Grid item>
        <Grid item container className={cssExports.iconContainer}>
          {typeof props.icon === "string" ? (
            <img src={props.icon} />
          ) : (
            <Icon className={cssExports.icon} icon={props.icon} />
          )}
        </Grid>
      </Grid>

      {!props.showIconOnly && (
        <Grid container item xs direction="column">
          <Grid
            item
            className={clsx(cssExports.name, cssExports.truncateString, props.plainTitle ? cssExports.plainTitle : "")}
          >
            {props.name}
          </Grid>
          <Grid item className={clsx(cssExports.description, cssExports.truncateString)}>
            {props.description}
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default IconProfile;
